import Axios from "./axios";

const resource = "reseller-shop-sliders";

export default {
  get(params) {
		return Axios.get(`${resource}`, params);
	}
}